
import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getDashboardReview } from "../services/dashboardApi";
import {
  SAMPLE_REVIEWS,
  getSampleEvaluation,
} from "../data/sampleDashboardData";

const ReviewDetailPage = () => {
  const { reviewId } = useParams();

  const [evaluationId, setEvaluationId] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const resolveReview = async () => {
      setLoading(true);
      setError("");
      setEvaluationId(null);

      // Sample reviews only: never send sample IDs to the real API.
      if (String(reviewId || "").startsWith("sample-review-")) {
        const sampleReview = SAMPLE_REVIEWS.find(
          (review) => String(review.id) === String(reviewId)
        );

        const sampleEvaluation = sampleReview
          ? getSampleEvaluation(sampleReview.evaluationId)
          : null;

        if (active) {
          if (sampleEvaluation) {
            setEvaluationId(sampleEvaluation.id);
          } else {
            setError("Sample review not found.");
          }
          setLoading(false);
        }
        return;
      }

      // Real reviews: original API-connected behaviour unchanged.
      try {
        const reviewResponse = await getDashboardReview(reviewId);

        const review = reviewResponse?.review || reviewResponse;

        const id =
          review?.evaluation_id ||
          review?.evaluationId ||
          review?.evaluation?.id;

        if (!id) {
          throw new Error("Evaluation ID unavailable for this review.");
        }

        if (active) {
          setEvaluationId(id);
        }
      } catch (err) {
        if (active) {
          setError(err?.message || "Unable to open this review.");
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    resolveReview();

    return () => {
      active = false;
    };
  }, [reviewId]);

  if (evaluationId) {
    return (
      <Navigate
        to={`/events/${encodeURIComponent(evaluationId)}`}
        replace
      />
    );
  }

  if (loading) {
    return (
      <div className="card">
        <div className="card-body p-40 text-center">
          Opening review...
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body p-40 text-center">
        <h6 className="mb-8">Unable to open review</h6>
        <p className="text-secondary-light mb-0">
          {error}
        </p>
      </div>
    </div>
  );
};

export default ReviewDetailPage;
